<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Tipo</th>
          <th>Data Envio</th>
          <th>Enviado por</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="documento in documentos" :key="documento._id">
          <td>{{ documento.nome }}</td>
          <td>{{ documento.tipo.valor }}</td>
          <td>{{ formatarData(documento.createdAt, 'DD/MM/YYYY') }}</td>
          <td>{{ documento.createdBy }}</td>
          <td
            ><button
              data-test-id="button-recuperardocumento-1"
              role="link"
              @click="recuperarDocumento(documento._id)"
              >Visualizar</button
            ></td
          >
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DocumentoServico from '@/servicos/DocumentoServico'
import * as formatadores from '@/utils/formatadores'
const documentoServico = new DocumentoServico()

export default {
  name: 'DocumentoTabela',
  props: {
    documentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    recuperarDocumento(documentoId) {
      documentoServico.recuperar(documentoId).then((resposta) => {
        this.documento = resposta.documento
        window.open(this.documento.link, '_blank')
      })
    },
  },
}
</script>
